import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

import { setPortal } from 'modules/portal';
import { advrtsLiveList } from 'lib/api/adverlive';

import MbInput from 'components/atoms/MbInput';
import MbButton from 'components/atoms/MbButton';
import MbTooltip from 'components/atoms/MbTooltip';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import Modal from './Modal';

const Statistics = () => {
  const initParams = {
    sort: 'desc',
    order: 'BDGT_LIMIT',
    advrtsPrdtCode: '01',
    advrtsTpCode: '06',
    crgrNo: 'all',
    pltfomTpCode: '01',
    uri: '/product/translist/live',
  };
  let tagetParams = {};
  const { t } = useTranslation();
  const mediaIdRef = useRef();
  const mediaScriptNoRef = useRef();
  const mediaSiteNoRef = useRef();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const [params, setParams] = useState(initParams);
  const [modalParams, setModalParams] = useState({
    open: false,
    type: '',
    params: {},
    rowData: { SITE_CODE: '' },
  });
  const [initialization, setInitialization] = useState(false);

  //키워드소재를 사용하는 타게팅 코드 리스트
  const keywordTargetingCode = [
    'KL',
    'KP',
    'MM',
    'KB',
    'IB',
    'KM',
    'IK',
    'PK',
    'MK',
    'MR',
    'GG',
    'GS',
    'MM',
    'MT',
  ];

  const [tableListCount, setTableListCount] = useState({
    adverCnt: 0,
    siteCnt: 0,
  });

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  /**
   * 필터 초기화
   * initialization 필터 내부에서 초기화 버튼이 클릭되었을 때 기본값으로 돌려주는 함수를 실행시킴.
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  /**
   * 필터 선택 관련
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    MANAGE_ICONS: { headStyle: { width: 70 } },
    USER_ID: { orderFlag: false },
    IMAGE_URL: {
      makeBody: (rowObj, headsMap) => {
        const imgUrl = '//img.mobon.net/ad/imgfile/' + rowObj['IMAGE_URL'];
        return !!rowObj['IMAGE_URL'] ? (
          <div>
            <img src={imgUrl} height="40px" alt="" />
          </div>
        ) : (
          t('배너 없음')
        );
      },
    },
    IMAGE_URL2: { merged: true },
    IMAGE_URL3: { merged: true },
    IMAGE_URL4: { merged: true },
    IMAGE_URL5: { merged: true },
    IMAGE_URL6: { merged: true },
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <IconAreaWrap>
            <MbTooltip title={t('사이트로 이동')}>
              <MbButton
                iconBtn
                icon={'faHome'}
                onClick={(e) => handlePortalUrl('http://' + data.URL)}
              />
            </MbTooltip>
            {keywordTargetingCode.includes(data.AD_TYPE) ? (
              <MbTooltip title={t('키워드매칭보기')}>
                <MbButton
                  iconBtn
                  icon={'faExternalLink'}
                  onClick={(e) => handleModalOpen(data, 'keyword')}
                />
              </MbTooltip>
            ) : null}
            {data.IMAGE_URL !== null ? (
              <MbTooltip title={t('전체이미지')}>
                <MbButton
                  iconBtn
                  icon={'faImages'}
                  onClick={(e) => handleModalOpen(data, 'images')}
                />
              </MbTooltip>
            ) : null}
          </IconAreaWrap>
        );
      },
    });
    return result;
  })();

  const handleModalOpen = (data, type) => {
    setModalParams({ ...modalParams, open: true, type: type, rowData: data });
  };

  const handleModalClose = () => {
    setModalParams({ ...modalParams, open: false });
  };

  /**
   * 인풋값 입력시
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const targetValue = value === '' ? null : value;
    tagetParams = {
      ...tagetParams,
      [name]: targetValue,
    };
  };

  /**
   * 검색버튼 클릭시
   */
  const handleSearchClick = () => {
    setParams({
      ...params,
      ...tagetParams,
    });
  };
  let tableTitle = '';
  if (tableListCount.adverCnt !== 'undefined') {
    tableTitle =
      t('광고주 수') +
      ' : ' +
      numeral(tableListCount.adverCnt).format() +
      ' / ' +
      t('이벤트 수') +
      ' : ' +
      numeral(tableListCount.siteCnt).format();
  }

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          getParam={getParam}
          initialization={initialization}
          params={params}
          useMediaTpCode
          useDate={false}
          useExternalFilter={false}
          pltfomTpCodeFixed={['01', '02']}
        />
        <MbInput
          key={'mediaId'}
          name="mediaId"
          onChange={handleInputChange}
          inputLabel={t('매체ID')}
          useFilter
          inputRef={mediaIdRef}
        />
        <MbInput
          key={'mediaScriptNo'}
          name="mediaScriptNo"
          onChange={handleInputChange}
          inputLabel={t('스크립트번호(S값)')}
          useFilter
          inputRef={mediaScriptNoRef}
        />
        <MbInput
          key="mediaSiteNo"
          name="mediaSiteNo"
          onChange={handleInputChange}
          inputLabel={t('매체No(us값)')}
          useFilter
          inputRef={mediaSiteNoRef}
        />
        <MbButton onClick={handleSearchClick} filterButton>
          {t('검색')}
        </MbButton>
      </NewFilterWrap>

      <NewTableContainer
        title={tableTitle}
        dataReqPromise={advrtsLiveList}
        params={params}
        getParam={getParam}
        addColumnList={addColumnList}
        customized={customized}
        useTotal={false}
        reFetch={false}
        useFetch={false}
        dataCallBack={(newCnt) => {
          setTableListCount(newCnt);
        }}
      />

      <Modal
        modalParams={modalParams}
        handleSubmit={handleModalClose}
        handleClose={handleModalClose}
      />
    </>
  );
};

export default Statistics;
